import React from 'react';
import VideoUploaderForStyleSettings from 'components/VideoUploader/VideoUploaderForStyleSettings';
import style from './CarouselItem.module.scss';

interface ICarouselVideoItem {
	filePath: Nullable<string>;
	translationId: string;
	sourceUrl: string;
	isMakeImageRequest: boolean;
}

const CarouselVideoItem: React.FC<ICarouselVideoItem> = ({
	filePath,
	translationId,
	sourceUrl,
	isMakeImageRequest,
}) => {
	return (
		<>
			{filePath ? (
				<VideoUploaderForStyleSettings
					translationID={translationId}
					isMakeImageRequest={isMakeImageRequest}
					loaderSize="big"
					isShowControls={true}
				/>
			) : (
				<video className={style.emblaSlideItem} controls={true} src={sourceUrl} />
			)}
		</>
	);
};

export default React.memo(CarouselVideoItem);
